<template>
    <div class="mian">
        <div class="img-list">
        <div>123</div>
            <div class="img-one-view">
                <img class="img-top" :src="'https://cdn.zxzx119.com/zxzx-mall-applet/activity/0101/image01.jpg?date='+date" alt="">
                    <img class="img-btn btn1" @click="postMsg(11489)"  :src="'https://cdn.zxzx119.com/zxzx-mall-applet/activity/0101/btn02.png?date='+date" alt="">
                    <img class="img-btn btn2" @click="postMsg(11488)" :src="'https://cdn.zxzx119.com/zxzx-mall-applet/activity/0101/btn01.png?date='+date" alt="">
            </div>
            <img :src="'https://cdn.zxzx119.com/zxzx-mall-applet/activity/0101/image02.jpg?date='+date" alt="">
        </div>
    </div>
</template>
    
<script>
import wxShare from '../../../wx/weixin.js'
export default {
    name:'downPayment',
    components: {
    },
    data () {
        return {
            isApp: 0, // 0: h5  1/2 : app  3: 小程序
            date :"",
        }
    },
    created() {
        this.isApp =  parseInt(this.$route.query.isApp)?parseInt(this.$route.query.isApp) : 0
        this.init()
        
    },
    mounted() {
        this.date = new Date().getTime()
        console.log(this.date)
        this.$nextTick(() => {
            document.addEventListener("UniAppJSBridgeReady", function () {
                uni.getEnv(function(res) {
                    // console.log('当前环境：' + JSON.stringify(res));
                });
            })
        })
    },
    methods: {
        postMsg(num) {
            console.log("isApp:", this.isApp)
            if (this.isApp == 3) {
                uni.navigateTo({//redirectTo
                    url : "/pages/goods-detail/goods-detail?goodId="+num,
                })
            } else if (this.isApp == 0) {//h5
                this.$router.push({
                    path: '/goodsdetail',
                    query: {
                        goodsId: num,
                        businessId: 26359
                    }
                    })
            } else if (this.isApp == 1||this.isApp == 2) {
                if (this.utils.isIphone()) { // ios 支付
                    window.webkit.messageHandlers.toActivityDownPayment.postMessage({'goodsId': num})
                } else {
                    window.zxzx.toActivityDownPayment(num)
                }
            }
        },  
        init() {
         var userAgent = navigator.userAgent;
            let imgUrl = 'https://cdn.zxzx119.com/zxzx-mall-applet/activity/0101/share.png'
            wxShare.wxRegister('兔年限量订金活动', '兔年限量订金活动  订金膨胀双倍支付', imgUrl)
        }
    },
   
}

</script>


<style lang='scss' scoped>
.img-list{
    .img-one-view{
        position: relative;
        .img-btn{
            position: absolute;
            width: 125px;
            height: 150px;
            bottom: 45px;
        }
        .btn2{
            left: 55px;
        }
        .btn1{
            right: 55px;
        }
       
    }
    img{
        display: block;
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/activity/downPayment/index.vue